import { getEntityclassByExternalId } from '@/repository/system.js';
import { loadCompanies } from '@/repository/bml';
import debounce from "debounce";

const maxEntitiesPerCall = 400;
const maxProductsPerCall = 200;


export function createDeferred() {
	const ret = {
		resolve: () => {},
		reject: () => {},
		promise: null,
	};
	ret.promise = new Promise((res, rej) => {
		ret.resolve = res;
		ret.reject = rej;
	});
	return ret;
}

const state = {
	idsWanted: [],
	idsUnavailable: [],
	entities: [],
	promises: {}
};
const getters = {
	byId: state => id => {
		return state.entities.find(e => e && e.id === id);
	}
};
const actions = {
	loadByIds({ dispatch }, ids) {
		return Promise.all(ids.map(id => dispatch('addRequiredEntity', { id })));
	},
	addRequiredEntity({ state, commit, dispatch }, { id }) {
		if (!id) throw new Error('must give id');
		if(!state.promises[id]) {
			commit('createPromise', id);
			commit('addId', id);
			dispatch('debouncedLoad');
		}
		return state.promises[id].promise;
	},
	debouncedLoad: debounce(async function loadRelated({ state, commit, dispatch }) {
		let ids = JSON.parse(JSON.stringify(state.idsWanted));
		if (ids.length === 0) return;
		let res = await loadCompanies(ids);
		let unavailable = [];
		res = res.filter((e, i) => {
			if (!e) {
				unavailable.push(ids[i]);
			}
			return !!e;
		});
		if (unavailable.length > 0) {
			commit('addUnavailable', unavailable);
		}
		commit('clearIds', ids);
		commit('addEntities', res);
	}, 100),
};

const mutations = {
	addId(state, id) {
		state.idsWanted.push(id);
	},
	addEntities(state, entities) {
		if (entities.length === 0) return;
		state.entities = state.entities.concat(entities);
		for (let ent of entities) {
			let key = ent.id;
			if (key in state.promises) {
				state.promises[key].resolve(ent);
			}
		}
	},
	clearIds(state, ids) {
		state.idsWanted = state.idsWanted.filter(id => !ids.includes(id));
	},
	clearAllIds(state) {
		state.idsWanted = [];
	},
	clearEntities(state) {
		state.entities = [];
	},
	addUnavailable(state, ids) {
		state.idsUnavailable = state.idsUnavailable.concat(ids);
		for (let id of ids) {
			let key = id;
			if (key in state.promises) {
				state.promises[key].reject(new Error('id not found: '+id));
			}
		}
	},
	createPromise(state, id) {
		state.promises[id] = createDeferred();
	},
	setIdsWantedProduct(state, val) {
		state.idsWantedProduct = val;
	}
};


export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};

